import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { AbstractPage } from '../abstract-page';
import { LoadingService } from '../../../providers/loading-service';

/**
 * Generated class for the PhotoConfirmPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-photo-confirm',
  templateUrl: 'photo-confirm.html',
})
export class PhotoConfirmPage extends AbstractPage{

	/* 写真データ */
	imageData:string = "";

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewController:ViewController, private loadingService:LoadingService) {
  	super();
  	this.imageData = this.navParams.get("imageData");
  	this.loadingService.dissmiss();
  }

  save(){
  	this.viewController.dismiss({isSave:true});
  }
}



// WEBPACK FOOTER //
// ./src/pages/_com/photo-confirm/photo-confirm.ts